<div class="content-with-side-menu">
    <div class="row no-gutters">
        @if (camp) {
            <div class="col-md-auto">
                <app-camp-care-booking-criteria
                    [searchForm]="searchForm"
                    [camp]="camp"
                ></app-camp-care-booking-criteria>
            </div>
        }

        <div class="col">
            <div
                class="row no-gutters top-panel height-80 line-height-40 padding-20"
            >
                @if (camp) {
                    <div class="col-md-auto">
                        <app-camp-icon
                            [iconName]="camp.categoryIcon"
                        ></app-camp-icon>
                    </div>
                }

                @if (camp) {
                    <div class="col line-height-20">
                        <div class="bolded">
                            {{ camp.campName }} ({{ camp.categoryName }})
                        </div>
                        <div>
                            {{ camp.startDate | bcDate }} -
                            {{ camp.endDate | bcDate }}
                        </div>
                    </div>
                }
            </div>

            <div>
                <app-camp-care-booking-calendar
                    [searchForm]="searchForm"
                ></app-camp-care-booking-calendar>
            </div>
        </div>
    </div>
</div>
